import { Fragment } from 'react';
import { PercentageDiscount } from '../../../Services/price';

const ProductTotalPrice = ({ order, showPercentageDiscount, cleanPrice }) => {
  return (
    <Fragment>
      {order.totalCampaignPrice ? (
        <Fragment>
          <div className="checkout-cart__campaign-price">
            {order.totalCampaignPrice}
          </div>
          <div className="checkout-cart__original-price">
            <span>{order.totalPrice}</span>
            {showPercentageDiscount && (
              <span className="product__price-discount">
                {PercentageDiscount(
                  order.totalPriceIncludingVat,
                  order.totalCampaignPriceIncludingVat
                )}
              </span>
            )}
          </div>
        </Fragment>
      ) : cleanPrice ? (
        order.totalPrice.replace(',00', '')
      ) : (
        order.totalPrice
      )}
    </Fragment>
  );
};

export default ProductTotalPrice;
